import angular from 'angular';
import angularOAuth2 from 'angular-oauth2';
import uiRouter from 'angular-ui-router';
import ngSanitize from 'angular-sanitize';
import myBookingApi from '../../../../api/mybooking/mybooking';
import viewComponent from './view.component';

const onTheBeachBookingViewModule = angular.module('onTheBeachBookingView', [
    uiRouter,
    angularOAuth2.name,
    ngSanitize,
    myBookingApi
])
    .config(($stateProvider) => {
        "ngInject";
        $stateProvider
            .state('onTheBeach.booking.view', {
                url: '/view',
                views: {
                    'booking@onTheBeach.booking': {
                        template: '<on-the-beach-booking-view></on-the-beach-booking-view>'
                    }
                }
            });
    })
    .component('onTheBeachBookingView', viewComponent)
    .name;

export default onTheBeachBookingViewModule;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/booking/view/view.js